import React from 'react'
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Career from "../components/career/Career";
function CareerPage() {
  return (
    <div>
        <Header/>
        <Career/>
        <Footer/>
    </div>
  )
}

export default CareerPage